<template>
  <el-form-item :label="label" :prop="prop" :inline-message="true">
    <el-input
      :class="[checkCode === 0 ? 'check-res' : '']"
      v-model.trim="inputVal"
      :placeholder="placeholder"
      clearable
      style="width: 350px"
      @blur="handleBlur"
      :type="showPassword ? 'text' : 'password'"
    >
      <i slot="suffix" @click="switchPassword">
        <img v-if="showPassword" class="input-icon" src="@/static/login/show-pwd.png" />
        <img v-else class="input-icon" src="@/static/login/close-pwd.png" />
      </i>
    </el-input>
    <div class="error-tip">
      <div class="flex-center">
        <img v-if="checkCode === 0" src="@/static/login/error-tip.png" class="error-tip-img" />
        <img v-if="checkCode === 1" src="@/static/login/success-tip.png" class="error-tip-img" />
        <span v-if="checkCode !== -1" :class="[checkCode === 1 ? 'success-tip' : '']">
          {{ checkMessage }}
        </span>
      </div>
    </div>
  </el-form-item>
</template>

<script >
import { ref, computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  value: {
    type: String || Number,
    default: () => ''
  },
  label: {
    type: String,
    default: () => ''
  },
  prop: {
    type: String,
    default: () => ''
  },
  placeholder: {
    type: String,
    default: () => '请输入'
  },
  // 校验状态  1 通过  0 失败  -1初始状态
  checkCode: {
    type: Number,
    default: () => -1
  },
  // 校验提示信息
  checkMessage: {
    type: String,
    default: () => ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const inputVal = computed({
    get() {
      return props.value;
    },
    set(val) {
      const _val = val.replace(/\s/g, '');
      emits('input', _val);
    }
  });

  // 失去焦点事件
  const handleBlur = () => {
    emits('blur');
  };

  // 切换密码显示、隐藏
  const showPassword = ref(false);
  const switchPassword = () => {
    showPassword.value = !showPassword.value;
  };
  return {
    inputVal,
    handleBlur,
    showPassword,
    switchPassword
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .error-tip {
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
    color: #fa5151;
    font-size: 14px;
    font-weight: 500;
    &-img {
      margin-right: 10px;
      width: 18px;
      height: 18px;
    }
  }
  .success-tip {
    color: #25de5e;
  }
  .input-icon {
    cursor: pointer;
    width: 16px;
    height: 12px;
    padding-right: 6px;
  }

  ::v-deep .el-form-item__label {
    font-size: 16px;
  }
  ::v-deep .el-input__inner {
    border: 1px solid #e5e7eb;
    background: #fafafa;
  }
  ::v-deep .el-input__inner:focus {
    background: #ffffff;
    border: 1px solid #22c655;
  }
  ::v-deep .el-form-item.is-error .el-input__inner {
    border-color: #fa5151;
  }
  ::v-deep .check-res .el-input__inner {
    border-color: #fa5151;
  }
</style>
